var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateStories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "248px",
    height: "248px",
    viewBox: "0 0 248 248",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C7717361-F92F-4332-9E42-A78CA6F47F16@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Start-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01X---Onboarding",
    transform: "translate(-62.000000, -21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(19.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-1",
    transform: "translate(43.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0,
    fill: "#FFFFFF",
    cx: 124,
    cy: 124,
    r: 124
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFF3DB",
    cx: 124,
    cy: 124,
    r: 68
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F1F2F4",
    cx: 124,
    cy: 222,
    rx: 50,
    ry: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "create-sories",
    transform: "translate(49.000000, 68.000000)",
    stroke: "#17243D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3035714,10.6 L0,13.2288 L-2.66453526e-13,107 L62.1964286,100.7 C62.1964286,104.3358 68.0180714,106 75.5,106 C82.9819286,106 88.8035714,104.3358 88.8035714,100.7 L150,106 L150,13.2288 L136.696429,10.6",
    id: "Stroke-12612",
    fill: "#FFD67E"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.1964286,
    y1: 100.7,
    x2: 62.1964286,
    y2: 92.75,
    id: "Stroke-12614"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.8035714,
    y1: 100.7,
    x2: 88.8035714,
    y2: 90.1,
    id: "Stroke-12616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9642857,95.4 C22.3868214,89.7237 38.6437857,88.5842 46.2321429,88.5842 C53.8205,88.5842 71.5727857,91.2872 75.5,95.4 L75.5,6.8158 C71.5727857,2.6977 53.8205,0 46.2321429,0 C38.6437857,0 22.3868214,1.1342 16.9642857,6.8158 L16.9642857,95.4 Z",
    id: "Stroke-12608",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,95.4 C80.9225357,89.7237 97.1795,88.5842 104.767857,88.5842 C112.356214,88.5842 130.1085,91.2872 134.035714,95.4 L134.035714,6.8158 C130.1085,2.6977 112.356214,0 104.767857,0 C97.1795,0 80.9225357,1.1342 75.5,6.8158 L75.5,95.4 Z",
    id: "Stroke-12610",
    fill: "#F1F2F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(26.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,5 C37.3163636,1.97900467 25.1854545,0 20,0 C14.8145455,0 3.70545455,0.832037325 0,5",
    id: "Stroke-12608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,15 C37.3163636,11.9790047 25.1854545,10 20,10 C14.8145455,10 3.70545455,10.8320373 0,15",
    id: "Stroke-12608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,25 C37.3163636,21.9790047 25.1854545,20 20,20 C14.8145455,20 3.70545455,20.8320373 0,25",
    id: "Stroke-12608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6965477,30.3277729 C22.8827197,30.1135504 21.2421034,30 20,30 C14.8145455,30 3.70545455,30.8320373 0,35",
    id: "Stroke-12608"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(99.701061, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5308169,27.3657529 L63.7461358,18.8480507 C65.7893925,12.9017771 66.9523626,6.63810442 66.9523626,0 C34.7363549,0 7.52930156,25.9845709 7.52930156,58.1980989 C29.7472379,58.1980989 50.1450889,47.203196 59.9943794,27.3657529 L48.5308169,27.3657529 Z",
    id: "Stroke-3447",
    fill: "#25D086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,72 C6.1099325,58.3766359 14.9251963,46.8188456 27.6310787,33.8600358",
    id: "Stroke-3446"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateStories);
export default __webpack_public_path__ + "static/media/create-stories.af748844f98cc4390a291cacb616d458.svg";
export { ForwardRef as ReactComponent };